jQuery(function ($) {
    const squareInit = async function (form) {
        // Create references to the main form and its submit button.
        var form, paymentBtn;

        const APPLICATION_ID = wp_travel.payment.squareup_application_id;
        const LOCATION_ID = wp_travel.payment.squareup_location_id;
        

        if ( $('#card-element').length < 1 ) {
            let cardElement = document.createElement('div')
            cardElement.classList.add('wp-travel-form-field', 'payment-card-field')
            var refElement = form.querySelector('.wp-travel-form-field.button-field')
            let cardEl = refElement.parentNode.insertBefore(cardElement, refElement)
            $(cardEl).html('<label>Card</label><div id="card-element"></div>')
        }

        var paymentElement = document.createElement("input");
        paymentElement.type = "submit";
        paymentElement.setAttribute('value', 'Book and Pay');
        paymentElement.setAttribute('id', 'square-payment');
        jQuery(paymentElement).insertAfter(jQuery('#wp-travel-book-now'))
        paymentBtn = form.querySelector('input#square-payment');

        async function initializeCard(payments) {
            const card = await payments.card();
            await card.attach('#card-element');
    
            return card;
        }

        async function createPayment(token) {
            jQuery('.wp-travel-form-field.button-field').find('.wt-icon.wt-icon-spinner').remove();
            let wt_parsley = jQuery('#wp-travel-booking').parsley();
            var l = jQuery("#wp-travel-payment-mode option:selected").val();
            let o = 0;
            if ($('[name=complete_partial_payment]').length > 0) {
                o = $('#wp-travel-amount').val(); // Added for partial payment.
            } else {
                o = "partial" == l ? wp_travel.payment.payment_amount : wp_travel.payment.trip_price;
                if ( ! wt_parsley.isValid()) {
                    wt_parsley.validate();
                    return;
                }
            }
            var booking_option = $('[name=wp_travel_booking_option]').val();
            if ('booking_with_payment' === booking_option) {
              // @todo Currency code for Japan is need to change from JPY to YEN in WP Travel.
              if ( ! ( 'USD' === wp_travel.payment.currency_code || 'GBP' === wp_travel.payment.currency_code || 'AUD' === wp_travel.payment.currency_code || 'CAD' === wp_travel.payment.currency_code || 'YEN' === wp_travel.payment.currency_code || 'JPY' === wp_travel.payment.currency_code ) ) {
                  alert('Squareup Checkout suppored currencies are : USD, GBP, AUD, CAD and YEN');
                  return;
                }

                jQuery('.wp-travel-form-field.button-field').append('<i class="wt-icon wt-icon-spin wt-icon-spinner"></i>');
                paymentBtn.disabled = true;

                var title = $('.entry-title').html() || 'Trip Book';

               // Payment Process start here
               const body = JSON.stringify({
                locationId: LOCATION_ID,
                sourceId: token,
                currency: wp_travel.payment.currency_code,
                currency_symbol: wp_travel.currency_symbol,
                title: title,
                amount: o,
                
              });
      
              const paymentResponse = await fetch( wp_travel.ajaxUrl + '?action=wptravel_sqaure_ajax_response', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body,
              });
              if (paymentResponse.ok) {
                return paymentResponse.json();
              }
      
              const errorBody = await paymentResponse.text();
              throw new Error(errorBody);
            }
          }
    
          async function tokenize(paymentMethod) {
            const tokenResult = await paymentMethod.tokenize();
            if (tokenResult.status === 'OK') {
              return tokenResult.token;
            } else {
              let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
              if (tokenResult.errors) {
                errorMessage += ` and errors: ${JSON.stringify(
                  tokenResult.errors
                )}`;
              }
    
              throw new Error(errorMessage);
            }
          }
    

        let paymentsSquare  = Square.payments(APPLICATION_ID, LOCATION_ID);
        let squareCard = await initializeCard(paymentsSquare);

        // Checkpoint 2.
        async function handlePaymentMethodSubmission(event, paymentMethod) {
            event.preventDefault();
            try {
              // disable the submit button as we await tokenization and make a payment request.
              paymentBtn.disabled = false;
              const token = await tokenize(paymentMethod);
              const paymentResults = await createPayment(token);
              if (paymentResults) {
                //   paymentBtn.disabled = false;
                  await squareCard.destroy();
                  paymentBtn.removeEventListener('click', handlePaymentMethodSubmission);
                  console.debug('Payment Success', paymentResults);
                  complete(paymentResults)
              }
            } catch (e) {
              paymentBtn.disabled = false;
            //   console.error(e.message);
            }
        }
  
        

        
        const square_trigger = function (e) {
            console.log( 'square trigger' );
        }

        const complete = async function (response) {
            var form_id = 'wp-travel-booking'; // Default payment form id
            paymentBtn.disabled = false;
            var payment_form_id = jQuery('#wp-travel-payment-form-id').val();

            if (payment_form_id) {
                form_id = payment_form_id;
            }
            jQuery('.loader-active').show();
            square_remove();
            setTimeout(function () {
                jQuery('[name=payment_details]').remove();
                jQuery('form#' + form_id).append(jQuery("<input type='hidden' name='payment_details' />").attr("value", JSON.stringify(response)));
                jQuery('form#' + form_id).find("[type=submit]").click();
            }, 2);
        };

        const square_checkout = function () {
            square_remove();
            var payment_gateway = jQuery('input[name=wp_travel_payment_gateway]').attr('type').match(/(radio|checkbox)/) && jQuery('input[name=wp_travel_payment_gateway]:checked').val() || jQuery('input[name=wp_travel_payment_gateway]').val()
            var booking_option = jQuery('[name=wp_travel_booking_option]').val();

            if ('squareup_checkout' === payment_gateway && 'booking_with_payment' === booking_option) {
                if ( squareCard && squareCard.attached ) {
                    console.log( 'Form Submitted.' );
                    paymentBtn.addEventListener('click', async function (event) {
                        await handlePaymentMethodSubmission(event, squareCard);
                    })
                }
                $('.payment-card-field').show();
                if (! squareCard.attached) {
                    squareCard.attach('#card-element');
                }

                jQuery("#square-payment, #wp-travel-complete-partial-payment").show().siblings().hide();

                jQuery(".paypal-button").remove();
                jQuery('[name=wp_travel_book_now], [name=complete_partial_payment]').click(square_trigger);
            } else {
                $('.payment-card-field').hide();
                $('.stripe-brand-logo').remove()
                if ( squareCard.attached) {
                    squareCard.destroy();
                }
            }
        }

        const square_remove = function () {
            jQuery('[name=wp_travel_book_now]').off('click', square_trigger);
            jQuery('[name=complete_partial_payment]').off('click', square_trigger);
        }

        jQuery(document).on('change', '[name=wp_travel_booking_option]', function () {
            square_checkout();
        });
        jQuery(document).on('change', '[name=wp_travel_payment_gateway]', function () {
            if (jQuery('[name=wp_travel_payment_gateway]').length > 1) {
                square_checkout();
            }
        });
        jQuery(document).on('change', '[name=wp_travel_payment_mode]', function () {
          if (jQuery('[name=wp_travel_payment_gateway]').length > 1) {
              square_checkout();
          }
      });

        // Checkout on load.
        square_checkout();
        // Parsley validation on load.
        $('#wp-travel-booking').length > 0 && $('#wp-travel-booking').parsley();
    }
    var form = document.getElementById('wp-travel-booking') || document.getElementById('wp-travel-partial-payment')
    form && wp_travel.payment.squareup_application_id.length > 0 && squareInit(form)
})